"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formatDate: true,
  fromNow: true,
  toLocalizedString: true,
  addDays: true,
  addHours: true,
  addMonths: true,
  addYears: true,
  dateToTimestamp: true,
  DayJSLocaleUtils: true,
  diff: true,
  diffDay: true,
  doRangesOverlap: true,
  formatDateRange: true,
  getAbsoluteDaysDiff: true,
  getAvailabilityLabel: true,
  getDateOfMonth: true,
  getDay: true,
  getMonth: true,
  getMonthsBetween: true,
  getToday: true,
  getYear: true,
  isBefore: true,
  isDayBetween: true,
  isFormat: true,
  startOf: true,
  subtractMonths: true,
  year: true
};
Object.defineProperty(exports, "formatDate", {
  enumerable: true,
  get: function get() {
    return _formatDate["default"];
  }
});
Object.defineProperty(exports, "fromNow", {
  enumerable: true,
  get: function get() {
    return _fromNow["default"];
  }
});
Object.defineProperty(exports, "toLocalizedString", {
  enumerable: true,
  get: function get() {
    return _toLocalizedString["default"];
  }
});
Object.defineProperty(exports, "addDays", {
  enumerable: true,
  get: function get() {
    return _addDays["default"];
  }
});
Object.defineProperty(exports, "addHours", {
  enumerable: true,
  get: function get() {
    return _addHours["default"];
  }
});
Object.defineProperty(exports, "addMonths", {
  enumerable: true,
  get: function get() {
    return _addMonths["default"];
  }
});
Object.defineProperty(exports, "addYears", {
  enumerable: true,
  get: function get() {
    return _addYears["default"];
  }
});
Object.defineProperty(exports, "dateToTimestamp", {
  enumerable: true,
  get: function get() {
    return _dateToTimestamp["default"];
  }
});
Object.defineProperty(exports, "DayJSLocaleUtils", {
  enumerable: true,
  get: function get() {
    return _DayJSLocaleUtils["default"];
  }
});
Object.defineProperty(exports, "diff", {
  enumerable: true,
  get: function get() {
    return _diff["default"];
  }
});
Object.defineProperty(exports, "diffDay", {
  enumerable: true,
  get: function get() {
    return _diffDay["default"];
  }
});
Object.defineProperty(exports, "doRangesOverlap", {
  enumerable: true,
  get: function get() {
    return _doRangesOverlap["default"];
  }
});
Object.defineProperty(exports, "formatDateRange", {
  enumerable: true,
  get: function get() {
    return _formatDateRange["default"];
  }
});
Object.defineProperty(exports, "getAbsoluteDaysDiff", {
  enumerable: true,
  get: function get() {
    return _getAbsoluteDaysDiff["default"];
  }
});
Object.defineProperty(exports, "getAvailabilityLabel", {
  enumerable: true,
  get: function get() {
    return _getAvailabilityLabel["default"];
  }
});
Object.defineProperty(exports, "getDateOfMonth", {
  enumerable: true,
  get: function get() {
    return _getDateOfMonth["default"];
  }
});
Object.defineProperty(exports, "getDay", {
  enumerable: true,
  get: function get() {
    return _getDay["default"];
  }
});
Object.defineProperty(exports, "getMonth", {
  enumerable: true,
  get: function get() {
    return _getMonth["default"];
  }
});
Object.defineProperty(exports, "getMonthsBetween", {
  enumerable: true,
  get: function get() {
    return _getMonthsBetween["default"];
  }
});
Object.defineProperty(exports, "getToday", {
  enumerable: true,
  get: function get() {
    return _getToday["default"];
  }
});
Object.defineProperty(exports, "getYear", {
  enumerable: true,
  get: function get() {
    return _getYear["default"];
  }
});
Object.defineProperty(exports, "isBefore", {
  enumerable: true,
  get: function get() {
    return _isBefore["default"];
  }
});
Object.defineProperty(exports, "isDayBetween", {
  enumerable: true,
  get: function get() {
    return _isDayBetween["default"];
  }
});
Object.defineProperty(exports, "isFormat", {
  enumerable: true,
  get: function get() {
    return _isFormat["default"];
  }
});
Object.defineProperty(exports, "startOf", {
  enumerable: true,
  get: function get() {
    return _startOf["default"];
  }
});
Object.defineProperty(exports, "subtractMonths", {
  enumerable: true,
  get: function get() {
    return _subtractMonths["default"];
  }
});
Object.defineProperty(exports, "year", {
  enumerable: true,
  get: function get() {
    return _year["default"];
  }
});
exports["default"] = void 0;

var _formatDate = _interopRequireDefault(require("./formatDate"));

var _fromNow = _interopRequireDefault(require("./fromNow"));

var _toLocalizedString = _interopRequireDefault(require("./toLocalizedString"));

var _addDays = _interopRequireDefault(require("./addDays"));

var _addHours = _interopRequireDefault(require("./addHours"));

var _addMonths = _interopRequireDefault(require("./addMonths"));

var _addYears = _interopRequireDefault(require("./addYears"));

var _dateToTimestamp = _interopRequireDefault(require("./dateToTimestamp"));

var _DayJSLocaleUtils = _interopRequireDefault(require("./DayJSLocaleUtils"));

var _diff = _interopRequireDefault(require("./diff"));

var _diffDay = _interopRequireDefault(require("./diffDay"));

var _doRangesOverlap = _interopRequireDefault(require("./doRangesOverlap"));

var _formatDateRange = _interopRequireDefault(require("./formatDateRange"));

var _getAbsoluteDaysDiff = _interopRequireDefault(require("./getAbsoluteDaysDiff"));

var _getAvailabilityLabel = _interopRequireDefault(require("./getAvailabilityLabel"));

var _getDateOfMonth = _interopRequireDefault(require("./getDateOfMonth"));

var _getDay = _interopRequireDefault(require("./getDay"));

var _getMonth = _interopRequireDefault(require("./getMonth"));

var _getMonthsBetween = _interopRequireDefault(require("./getMonthsBetween"));

var _getToday = _interopRequireDefault(require("./getToday"));

var _getYear = _interopRequireDefault(require("./getYear"));

var _isBefore = _interopRequireDefault(require("./isBefore"));

var _isDayBetween = _interopRequireDefault(require("./isDayBetween"));

var _isFormat = _interopRequireDefault(require("./isFormat"));

var _startOf = _interopRequireDefault(require("./startOf"));

var _subtractMonths = _interopRequireDefault(require("./subtractMonths"));

var _year = _interopRequireDefault(require("./year"));

var _constants = require("./constants");

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var haDateFactory = function haDateFactory(locale) {
  return {
    locale: locale,
    formatDate: (0, _formatDate["default"])(locale),
    fromNow: (0, _fromNow["default"])(locale),
    toLocalizedString: (0, _toLocalizedString["default"])(locale)
  };
};

var _default = haDateFactory;
exports["default"] = _default;